import { canExposePilotSurface } from "@enrein/shared-contracts/pilot-exposure";
import { LaunchCertificateSummaryPanel } from "../../../LaunchCertificateSummaryPanel.js";
import { ReportsPanel } from "../../../ReportsPanel.js";
import { WebsiteOwnershipChecklistPanel } from "../../../WebsiteOwnershipChecklistPanel.js";
import { GovernancePanel } from "../../../GovernancePanel.js";
import type { V10ClientLinkViewProps } from "../types.js";
import { V10EvidenceLegacyScope } from "./V10EvidenceLegacyScope.js";

export function V10HandoffEvidenceHub({
  active,
  api,
  linkId,
  token,
  deployEnv,
}: {
  readonly active: boolean;
  readonly api: V10ClientLinkViewProps["api"];
  readonly linkId: string;
  readonly token: string;
  readonly deployEnv: V10ClientLinkViewProps["deployEnv"];
}) {
  if (!active) return null;
  const exposureInput = {
    deployEnv,
    nodeEnv: import.meta.env.MODE,
    explicitFlags: import.meta.env.VITE_ENREIN_PILOT_FEATURE_FLAGS,
  };
  const showGovernance = canExposePilotSurface("client.governancePanel", "client", exposureInput).enabled;
  const showCertificate = canExposePilotSurface("client.launchCertificateSummary", "client", exposureInput).enabled;

  return (
    <div className="v10-cl-evidence-stack">
      <V10EvidenceLegacyScope>
        <ReportsPanel api={api} clientLinkId={linkId} token={token} />
      </V10EvidenceLegacyScope>
      {showCertificate ? (
        <V10EvidenceLegacyScope>
          <LaunchCertificateSummaryPanel api={api} clientLinkId={linkId} token={token} />
        </V10EvidenceLegacyScope>
      ) : null}
      <V10EvidenceLegacyScope>
        <WebsiteOwnershipChecklistPanel api={api} clientLinkId={linkId} token={token} />
      </V10EvidenceLegacyScope>
      {showGovernance ? (
        <V10EvidenceLegacyScope>
          <GovernancePanel api={api} clientLinkId={linkId} token={token} />
        </V10EvidenceLegacyScope>
      ) : null}
    </div>
  );
}
